import React from 'react';
import { StyleSheet, Text, View } from './components/base_components';

import Breadcrumb from './components/breadcrumb';
import ProgressSpinner from './components/progress_spinner';
import OrgTabBar from './components/org_tab_bar';
import StandardBoxList from './components/standard_box_list';

import OrgStore from './stores/org_store';
import InvoiceStore from './stores/invoice_store';
import UserStore from './stores/user_store';

import { dateFormat, moneyFormat } from './tools/util';

const styles = StyleSheet.create({
  orgInvoiceListScreen: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  spinner: { margin: '3rem', alignSelf: 'center' },
  tabBar: { marginLeft: '2.2rem', marginRight: '2.2rem' },
  dialog: { marginLeft: '2rem', marginBottom: '2rem', flexDirection: 'column' },
  text: { marginTop: '1em', fontSize: '1.5em' },
});

export default function OrgInvoiceListScreen() {
  const org_id = UserStore.useOrg()?.org_id;
  const org = OrgStore.useOrg(org_id);
  const invoice_list = InvoiceStore.useList(org_id);

  React.useEffect(() => {
    OrgStore.fetch(org_id);
    InvoiceStore.fetch(org_id);
  }, [org_id]);

  let content: any = null;
  if (!org || !invoice_list) {
    content = <ProgressSpinner style={styles.spinner} color='#555' />;
  } else {
    const rows = invoice_list.map((invoice) => ({
      url: `/org/invoice/${invoice.invoice_id}`,
      list: [
        `#${invoice.invoice_id.slice(0, 8)}`,
        dateFormat(invoice.invoice_date, 'yyyy-MM-dd'),
        moneyFormat(invoice.total_usd),
        invoice.invoice_status,
      ],
    }));
    let empty: any = null;
    if (rows.length === 0) {
      empty = (
        <View style={styles.dialog}>
          <Text style={styles.text}>No invoices found.</Text>
        </View>
      );
    }

    content = (
      <>
        <Breadcrumb list={[{ text: org?.org_name, url: `/org` }, 'Invoices']} />
        <OrgTabBar style={styles.tabBar} />
        <StandardBoxList
          title='Invoices'
          headers={['Invoice ID', 'Date', 'Amount', 'Status']}
          rows={rows}
        >
          {empty}
        </StandardBoxList>
      </>
    );
  }
  return <View style={styles.orgInvoiceListScreen}>{content}</View>;
}
